
import { Component, ViewChild } from "@angular/core";
import { ModelService } from "../../../Services/model.service";
import { Catalog } from "../../../Model/Catalog/Catalog";
import { DxFileUploaderComponent } from "devextreme-angular";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
    selector: "importTranslations",
    templateUrl: "importTranslations.component.html",
    standalone: false
})
export class ImportTranslationsComponent {
  @ViewChild(DxFileUploaderComponent, { static: true })
  dxfileuploader: DxFileUploaderComponent;

  value: any[] = [];
  model: Catalog[];
  uploadHeaders: any;

  constructor(private modelService: ModelService, private oAuthService: OAuthService) {
    this.onBeforeSendUpload = this.onBeforeSendUpload.bind(this);

    this.uploadHeaders = {
      CustomerId: this.modelService.loginService.currentUser.customerId
    }
  }

  onBeforeSendUpload(e: { request: XMLHttpRequest }) {
    e.request.withCredentials = true;
    e.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
  }

  onUploaded() {
    this.dxfileuploader.instance.reset();
  }
}
